import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { BakimPlaniEditComponent } from './bakim-plani-edit.component';
import { BakimPlaniKartComponent } from './bakim-plani-kart.component';

@DinamikBilesen({
  id: 'bakim-plani',
  baslik: 'Bakım Planı',
  aciklama: 'Periyodik bakım planı ekle',
  ikon: 'tool',
  kategori: 'makine',
})
class BakimPlani {
  paylas_kutusu = BakimPlaniEditComponent;
  paylasilmis_kart = BakimPlaniKartComponent;
}
